import { ethers } from 'ethers';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAccount, useBalance, useNetwork, useProvider, useSigner, useSwitchNetwork } from 'wagmi';
import { TabView, TabPanel } from 'primereact/tabview';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { ProgressBar } from 'primereact/progressbar';
import globeImg from '../../assets/images/globe.png';
import arrowUpImg from '../../assets/images/arrow-up-right.png';
import eternalLinkImg from '../../assets/images/external-link.png';
import erc20Json from '../../abi/out/ERC20.sol/ERC20.json'
import dollarImg from '../../assets/images/dollar.png';
import zapIMg from '../../assets/images/zap.png';
import riveraAutoCompoundingVaultV2WhitelistedJson from '../../abi/out/RiveraAutoCompoundingVaultV2Whitelisted.sol/RiveraAutoCompoundingVaultV2Whitelisted.json'
import StablePairColorImg from '../../assets/images/StablePairColor.svg';
import VolatilePairColorImg from '../../assets/images/volatilePair.png';
import dynamicStrategyImg from '../../assets/images/dynamicStrategy.png';
import almImg from '../../assets/images/alm.svg';
import trend from '../../assets/images/Trending.png';
import boosted from '../../assets/images/Boosted 2.svg';
import LSDFarmingImg from '../../assets/images/LSDFarming.svg';
import { Toast } from 'primereact/toast';
import Decimal from 'decimal.js';
import depositTabImg from '../../assets/images/depositTab.svg';
import withdrwaTabImg from '../../assets/images/withdrwaTab.svg';
import waitingImg from '../../assets/images/waiting.gif';
import successfullImg from '../../assets/images/successfull.gif';
import revenueEarningImg from '../../assets/images/revenueEarning.svg';
import { Dialog } from 'primereact/dialog';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Legend,
  Tooltip as TooltipChart
} from 'chart.js';
import ConnectBtn from '../../component/ConnectBtn';
import infoCircleImg from '../../assets/images/info_circle.svg';
import { Tooltip } from 'primereact/tooltip';
import { Skeleton } from 'primereact/skeleton';
import Web3 from 'web3';
import ProgressComparison from './ProgressBar';

interface Product {
  id: string;
  code: string;
  name: string;
  description: string;
  image: string;
  price: number;
  category: string;
  quantity: number;
  inventoryStatus: string;
  rating: number;
}

export default function VaultDetails() {

  const [rangeStatistics, setRangeStatistics] = useState<any>();
  const [isDataLoadng, setIsDataLoadng] = useState(false);
  //const [vaultShare, setVaultShare] = useState(0);
  const overview = useRef(null);
  const lpTokenDetails = useRef(null);
  const strategy = useRef(null);
  const yieldToken = useRef(null);
  const risk = useRef(null);
  const portfolioManager = useRef(null);
  const fees = useRef(null);
  const transactions = useRef(null);
  const depositors = useRef(null);
  const fAQ = useRef(null);

  const toast = useRef<Toast>(null);
  const [deatils, setDeatils] = useState({
    "vaultName": "",
    "symbol": "",
    "assetName": "",
    "assetImg": "",
    "assetImg2": "",
    "denoImage": "",
    "asset1": "",
    "asset2": "",
    "tvl": "",
    "tvlInusd": "",
    "holding": "",
    "networkImg": "",
    "fundManger": "",
    "vaultReturn": "",
    "vaultOwner": "",
    "rpc": "",
    "vaultAddress": "",
    "denominationDecimal": 0,
    "explorerLink": "",
    "poweredBy": "",
    "chainId": "",
    "chainName": "",
    "lpApr": 0,
    "totalSupply": 0,
    "currentTick": 0,
    "xirvApr": 0,
    "totalApr": 0,
    "feeTier": Number,
    "partnerFee": 0,
    "feeDecimals": 0,
    "withdrawFee": 0,
    "fundManagerFee": 0,
    "protocolFee": 0,
    "withdrawFeeDecimals": 0,
    "buyToken": "",
    "detailsNew": "",
    "website": "",
    "dex": [],
    "tags": [],
    "apr": [],
    "strategyType": [],
    "description": "",
    "stTypes": "",
    "tickLower": 0,
    "tickUpper": 0,
    "lp0Decimal": 0,
    "lp1Decimal": 0,
    "lp0Name": "",
    "lp1Name": "",
  });
  const [transaction, setTransaction] = useState([{
    "date": "",
    "type": "",
    "txHash": "",
    "txfee": "",
    "value": "",
  }]);
  const [transactionType, setTransactionType] = useState("");
  const [isWhiteListed, setWhiteListed] = useState(false);
  const [maxLimit, setMaxLimit] = useState<any>(null);
  const [valutJsonData, setValutJsonData] = useState<any>();
  const [latestBlockNumber, setLatestBlockNumber] = useState(0);
  const [tvlCap, setTvlCal] = useState("");
  const [userTvlCap, setUserTvlCap] = useState("");

  const [tvlCapInUsd, setTvlCalInUsd] = useState("");
  const [userTvlCapInUsd, setUserTvlCapInUsd] = useState("");

  const [depositerNumber, setDepositerNumber] = useState("");

  const [userApy, setUserApy] = useState("");
  const [vaultApy, setVaultApy] = useState<any>(null);
  const [holding, setHolding] = useState("");
  const [userShare, setUserShare] = useState("0");
  const [userPrice, setUserPrice] = useState("0");

  const [userShareInUsd, setUserShareInUsd] = useState("");
  const [useroverallReturn, setUserOverallReturn] = useState("");
  const [isApproved, setisApproved] = useState(false);
  const [depositAmout, setdepositAmout] = useState<any>("0");
  const [withdrawAmout, setwithdrawAmout] = useState("0");
  const provider = useProvider();
  const { data: signer } = useSigner();
  const { address, isConnected } = useAccount()
  const [products, setProducts] = useState<Product[]>([]);
  let { vaultAddress } = useParams();
  const [loading, setLoading] = useState(false);
  const [isTransactionOnGoing, setIsTransactionOnGoing] = useState(false);
  const balance = useBalance({
    address: '0x8734110e5e1dcF439c7F549db740E546fea82d66',
  });
  const switchNetwork = useSwitchNetwork();
  const { chain } = useNetwork();

  const [walletBalance, setWalletBalance] = useState<any>(null);
  const [assetAbiVal, setAssetAbi] = useState(null);
  const [approvalWaitingVisible, setapprovalWaitingVisible] = useState<boolean>(false);
  const [approvalSuccessfullVisible, setapprovalSuccessfullVisible] = useState<boolean>(false);
  const [openMetamaskVisible, setOpenMetamaskVisible] = useState<boolean>(false);
  const [depositWaitingVisible, setdepositWaitingVisible] = useState<boolean>(false);
  const [depositSuccessfullVisible, setdepositSuccessfullVisible] = useState<boolean>(false);

  const [graphOption, setGraphOption] = useState<any>();
  const [graphData, setgraphData] = useState<any>();
  const [newSingle, setNewSingle] = useState<any>()

  const [token0Dec, setToken0Dec] = useState<number>()
  const [token1Dec, setToken1Dec] = useState<number>()


  useEffect(() => {
    setLoading(true);
    setIsDataLoadng(true);
    getBakcendApiDetails();
    (async () => {
      const response = await fetch('/vaultDetails.json');
      const valutData = await response.json();
      setValutJsonData(valutData[vaultAddress as string]);
      setToken0Dec(deatils.lp0Decimal)
      setToken1Dec(deatils.lp1Decimal)
      // if (address) {
      //   const response = await fetch('./abi/wmntAbi.json');
      //   const data = await response.json();
      //   setAssetAbi(data?.abi);
      //   assetValueUpdate(data?.abi);
      // }

    })();
  }, [address]);

  const getActualvalue = (num: any, decimal: any) => {
    const roundedNum = Number(new Decimal(num.toString()).div(new Decimal(Math.pow(10, Number(decimal)))));
    return roundedNum;
  }

  const getBakcendApiDetails = async () => {
    const vaultData = await fetch(`https://api.rivera.money/vaults/?identifier=${vaultAddress}`);
    let vaultJsonData = await vaultData.json();
    let vaultJsonSingleData = vaultJsonData.find((e: any) => e.identifier.toLowerCase() === (vaultAddress as string).toLowerCase())

    const geckoData = await fetch("https://api.rivera.money/oracle/coingecko");
    let geckoJsonData = await geckoData.json();


    const denominationAssetPrice = geckoJsonData.find((e: any) => e.denominationAssetAddress.toLowerCase() === vaultJsonSingleData.denominationAssetAddress.toLowerCase());

    const tvl = getActualvalue(vaultJsonSingleData.totalAssets, vaultJsonSingleData.denominationDecimal);
    const tvlCap = getActualvalue(vaultJsonSingleData.totalTvlCap, vaultJsonSingleData.denominationDecimal);

    const currentShareValurInMnt = new Decimal(vaultJsonSingleData?.totalAssets).div(new Decimal(vaultJsonSingleData?.totalSupply));

    const denoImg = vaultJsonSingleData?.denominationAsset;
    const asset1 = vaultJsonSingleData.lpToken0.name.toLowerCase()
    const asset2 = vaultJsonSingleData.lpToken1.name.toLowerCase()
    const website = vaultJsonSingleData?.dex?.website || '';


    const detailsValFirstV2 = {
      "vaultName": vaultJsonSingleData?.displayName,
      "symbol": vaultJsonSingleData?.symbol,
      "assetName": vaultJsonSingleData?.denominationAsset,
      "assetImg": `../image/assets/${asset1.toLowerCase()}.png`,
      "assetImg2": `../image/assets/${asset2.toLowerCase()}.png`,
      "denoImage": `../image/assets/${denoImg.toLowerCase()}.png`,
      "asset1": `${asset1}`,
      "asset2": `${asset2}`,
      "tvl": tvl.toFixed(2),
      "tvlInusd": vaultJsonSingleData?.tvlUSD,
      "holding": "",
      "totalSupply": vaultJsonSingleData?.totalSupply,
      "networkImg": `../image/chain/${vaultJsonSingleData?.chain?.chain}.png`,
      "fundManger": vaultJsonSingleData?.manager,
      "vaultReturn": Number(currentShareValurInMnt).toFixed(2),
      "vaultOwner": vaultJsonSingleData?.owner,
      "poweredBy": `../image/dex/${vaultJsonSingleData?.dex?.dex}.png`,
      "rpc": vaultJsonSingleData?.chainRPC,
      "currentTick": vaultJsonSingleData?.currentTick,
      "vaultAddress": vaultJsonSingleData?.vaultAddress,
      "denominationDecimal": vaultJsonSingleData?.denominationDecimal,
      "explorerLink": vaultJsonSingleData?.chain?.chainExplorer,
      "chainId": vaultJsonSingleData?.chain?.chainID,
      "chainName": vaultJsonSingleData?.chain?.displayName,
      "lpApr": vaultJsonSingleData?.apr?.lpAPR * 100,
      "xirvApr": vaultJsonSingleData?.apr?.apr * 100,
      "totalApr": vaultJsonSingleData?.apr?.apr + vaultJsonSingleData?.apr?.lpAPR * 100,
      "feeTier": vaultJsonSingleData?.poolFee,
      "partnerFee": parseFloat(vaultJsonSingleData?.partnerFee || '0'),
      "feeDecimals": parseFloat(vaultJsonSingleData?.feeDecimals || '0'),
      "withdrawFee": parseFloat(vaultJsonSingleData?.withdrawFee || '0'),
      "fundManagerFee": parseFloat(vaultJsonSingleData?.fundManagerFee || '0'),
      "protocolFee": vaultJsonSingleData?.protocolFee,
      "withdrawFeeDecimals": vaultJsonSingleData?.withdrawFeeDecimals,
      "tags": vaultJsonSingleData?.tags,
      "apr": vaultJsonSingleData?.apr,
      "dex": vaultJsonSingleData?.dex,
      "buyToken": vaultJsonSingleData?.dex?.buyToken,
      "website": website,
      "tickUpper": vaultJsonSingleData?.tickUpper,
      "tickLower": vaultJsonSingleData?.tickLower,
      "lp0Decimal": vaultJsonSingleData?.lpToken0.decimals,
      "lp1Decimal": vaultJsonSingleData?.lpToken1.decimals,
      "lp0Name": vaultJsonSingleData?.lpToken0.name,
      "lp1Name": vaultJsonSingleData?.lpToken0.name,
      "detailsNew": vaultJsonSingleData?.dex.details,
      "strategyType": vaultJsonSingleData?.strategyType,
      "stTypes": vaultJsonSingleData?.strategyType.strategyType,
      "description": vaultJsonSingleData?.strategyType.description,
    }


    setVaultApy((Number(detailsValFirstV2?.totalApr)));
    setDeatils(detailsValFirstV2);
    setTvlCal(tvlCap.toFixed(2));
    setLoading(true);

    const tvlCapInUsdval = (new Decimal(tvlCap).mul(new Decimal(denominationAssetPrice?.priceUSD.toString()))).toFixed(18); //calculation wth decimal js
    setTvlCalInUsd(tvlCapInUsdval);


    if (address) {
      setWhiteListed(true);
      let localProvider;
      let vaultContract;
      const web3 = new Web3(vaultJsonSingleData.chainRPC);
      localProvider = web3.eth.currentProvider;
      vaultContract = getContract(vaultJsonSingleData.vaultAddress as string, riveraAutoCompoundingVaultV2WhitelistedJson.abi, localProvider);

      //ger user share
      let share = await vaultContract.methods.balanceOf(address).call() as any;
      let priceSec = await vaultContract.methods.convertToAssets(1000).call() as any;
      let userShareVal = await vaultContract.methods.convertToAssets(share).call() as any;

      setUserPrice(ethers.utils.formatUnits(priceSec));
      setUserShare(ethers.utils.formatUnits(userShareVal, Number(vaultJsonSingleData.denominationDecimal)));

      //check user allowance
      const erc20Contract = getContract(vaultJsonSingleData?.denominationAssetAddress, erc20Json.abi, localProvider)
      const allowance = await erc20Contract.methods.allowance(address, vaultJsonSingleData.vaultAddress).call() as any;


      //address:- login user address  //assetAdress:-valut asset address
      setMaxLimit(ethers.utils.formatUnits(allowance, vaultJsonSingleData.denominationDecimal));
      const maxLimitVal = new Decimal(ethers.utils.formatUnits(allowance, vaultJsonSingleData.denominationDecimal));
      const despositAmtVal = new Decimal(depositAmout);

      if (despositAmtVal.gt(maxLimitVal)) {
        setisApproved(false);
      } else {
        setisApproved(true);
      }

      const response = await fetch('./abi/wmntAbi.json');
      const data = await response.json();
      setAssetAbi(data?.abi);
      assetValueUpdate(data?.abi, detailsValFirstV2);

    }
    setIsDataLoadng(false);
    setLoading(false);
  }

  const checkAllowance = async () => {

    let localProvider;
    let vaultContract;
    const web3 = new Web3(deatils.rpc);
    localProvider = web3.eth.currentProvider;
    vaultContract = getContract(deatils.vaultAddress as string, riveraAutoCompoundingVaultV2WhitelistedJson.abi, localProvider);

    const valutAssetAdress = await vaultContract.methods.asset().call() as any;

    const erc20Contract = getContract(valutAssetAdress, erc20Json.abi, localProvider)
    const allowance = await erc20Contract.methods.allowance(address, deatils.vaultAddress).call() as any; //address:- login user address  //assetAdress:-valut asset address

    setMaxLimit(ethers.utils.formatUnits(allowance, deatils.denominationDecimal));
    const maxLimitVal = new Decimal(ethers.utils.formatUnits(allowance, deatils.denominationDecimal));
    const despositAmtVal = new Decimal(depositAmout);

    if (despositAmtVal.gt(maxLimitVal)) {
      setisApproved(false);
      return false;
    } else {
      setisApproved(true);
      return true;
    }
  }

  const assetValueUpdate = async (abi?: any, localDeatils?: any) => {
    let localProvider;
    let vaultContract;

    if (localDeatils) {
      const web3 = new Web3(localDeatils.rpc);
      localProvider = web3.eth.currentProvider;
      vaultContract = getContract(localDeatils.vaultAddress as string, riveraAutoCompoundingVaultV2WhitelistedJson.abi, localProvider);
    } else {
      const web3 = new Web3(deatils.rpc);
      localProvider = web3.eth.currentProvider;
      vaultContract = getContract(deatils.vaultAddress as string, riveraAutoCompoundingVaultV2WhitelistedJson.abi, localProvider);
    }
    const valutAssetAdress = await vaultContract.methods.asset().call() as any;


    if (abi) {
      const asstsContract = getContract(valutAssetAdress, abi, localProvider);
      const balance = await asstsContract.methods.balanceOf(address).call() as any;
      setWalletBalance(ethers.utils.formatUnits(balance, localDeatils.denominationDecimal));
    }
    else {
      const asstsContract = getContract(valutAssetAdress, assetAbiVal, localProvider);
      const balance = await asstsContract.methods.balanceOf(address).call() as any;
      setWalletBalance(ethers.utils.formatUnits(balance, deatils.denominationDecimal));
    }

  }
  const approveIntilize = async () => {

    const contract = getEtherContract(deatils.vaultAddress as string, riveraAutoCompoundingVaultV2WhitelistedJson.abi, signer);
    const assetAdress = await contract.asset();
    await approve(assetAdress);
  }

  async function approve(assetsAddress: string) {
    const gasPrice = await provider.getGasPrice();

    const contract = getEtherContract(assetsAddress, erc20Json.abi, signer);
    try {

      setIsTransactionOnGoing(true);

      const aa = Decimal.pow(10, deatils.denominationDecimal);
      const bb = new Decimal(depositAmout);

      const convertedAmount = bb.mul(aa).toFixed();

      let aprvTxt;
      if (deatils.chainName.toLowerCase() === 'mantle') {
        const estimatedGasFee = await contract.estimateGas.approve(deatils.vaultAddress, convertedAmount);
        aprvTxt = await contract.approve(deatils.vaultAddress, convertedAmount, {
          gasLimit: estimatedGasFee
        });
      } else {
        aprvTxt = await contract.approve(deatils.vaultAddress, convertedAmount);
      }
      setapprovalWaitingVisible(true);
      await aprvTxt.wait().then(async (e: any) => {
        setapprovalWaitingVisible(false);
        setapprovalSuccessfullVisible(true);
        const isApproveVal = await checkAllowance();
        await deposit(isApproveVal);

        setIsTransactionOnGoing(false);
      }).catch((error: any) => {
        setIsTransactionOnGoing(false);
        showError("Something went wrong");
      });

    } catch (err: any) {
      console.log('revert reason:', err.message);
    }
  }
  const deposit = async (isApprovedVal?: boolean) => {
    const gasPrice = await provider.getGasPrice();

    setTransactionType("Deposit");
    const despositAmtVal = new Decimal(depositAmout);
    const walletBalanceVal = new Decimal(walletBalance);

    if (isApprovedVal !== undefined && !isApprovedVal) {
      const message = "Approved amount is lower than Deposit amount. Please try again.";
      showWarn("Warning", message);
      return;
    }

    if (despositAmtVal.lt(new Decimal("0.0001"))) {
      const message = "Min Limit 0.0001";
      showWarn("Warning", message);
      return;
    }

    if (despositAmtVal.gt(walletBalanceVal)) {
      const message = "Insufficient Balance";
      showWarn("Warning", message);
      return;
    }

    if ((Number(deatils.tvl) + Number(depositAmout)) > Number(tvlCap)) {
      showWarn("Warning", "Vault Capacity Reached");
      return;
    }
    setIsTransactionOnGoing(true);

    const contract = getEtherContract(deatils.vaultAddress as string, riveraAutoCompoundingVaultV2WhitelistedJson.abi, signer);

    const aa = Decimal.pow(10, deatils.denominationDecimal);
    const bb = new Decimal(depositAmout);

    const convertedAmount = bb.mul(aa).toFixed();
    //calling the deposit method
    let aprvTxt
    if (deatils.chainName.toLowerCase() === 'mantle') {
      const estimatedGasFee = await contract.estimateGas.deposit(convertedAmount, address);
      aprvTxt = await contract.deposit(convertedAmount, address, {
        gasLimit: estimatedGasFee
      });
    } else {
      aprvTxt = await contract.deposit(convertedAmount, address, {
        gasLimit: 3000000
      });
    }
    const intValue = aprvTxt as any;
    setapprovalSuccessfullVisible(false);
    setdepositWaitingVisible(true)
    await intValue.wait().then(async (e: any) => {
      setdepositWaitingVisible(false);

      setdepositSuccessfullVisible(true);
      // await checkAllowance();
      // await assetValueUpdate();
      await getBakcendApiDetails();
      setIsTransactionOnGoing(false);
    }).catch((error: any) => {
      setLoading(false);
      setIsTransactionOnGoing(false);
      showError("Something went wrong");
    });
  }

  const withdraw = async () => {
    const gasPrice = await provider.getGasPrice();

    
    setTransactionType("Withdraw");
    const withdrawAmoutVal = new Decimal(withdrawAmout);
    const userHohlding = new Decimal(userShare);

    if (withdrawAmoutVal.lt(new Decimal("0.0001"))) {
      const message = "Min Limit 0.0001";
      showWarn("Warning", message);
      return;
    }

    if (withdrawAmoutVal.gt(userHohlding)) {
      const message = "Insufficient Holdings";
      showWarn("Warning", message);
      return;
    }
    const contract = getEtherContract(deatils.vaultAddress as string, riveraAutoCompoundingVaultV2WhitelistedJson.abi, signer);
    const aa = Decimal.pow(10, deatils.denominationDecimal);
    const bb = new Decimal(withdrawAmout);

    const convertedAmount = bb.mul(aa).toFixed();

    setIsTransactionOnGoing(true);
    let aprvTxt
    if (deatils.chainName.toLowerCase() === 'mantle') {
      const estimatedGasFee = await contract.estimateGas.withdraw(convertedAmount, address, address);
      aprvTxt = await contract.withdraw(convertedAmount, address, address, {
        gasLimit: estimatedGasFee
      });
    } else {
      aprvTxt = await contract.withdraw(convertedAmount, address, address, {
        gasLimit: 3000000
      });
    }
    const intValue = aprvTxt as any;
    setdepositWaitingVisible(true);
    await intValue.wait().then(async (e: any) => {
      setdepositWaitingVisible(false);
      setdepositSuccessfullVisible(true);
      //await checkAllowance();
      await getBakcendApiDetails();
      setIsTransactionOnGoing(false);
      //assetValueUpdate();
    }).catch((error: any) => {
      setIsTransactionOnGoing(false);
      showError("Something went wrong");
    });
  }

  const handledepositAmoutChange = (event: any) => {
    let val = event.target.value;
    if (val === "") {
      val = "0";
    }
    const enteredVal = new Decimal(val);
    const mxlmtVal = new Decimal(maxLimit);
    if (enteredVal.gt(mxlmtVal)) {
      setisApproved(false);
    } else {
      setisApproved(true);
    }
    setdepositAmout(event.target.value);
  };

  const updateDepositMax = () => {
    setdepositAmout(walletBalance);
    const walletBalanceVal = new Decimal(walletBalance);
    const maxLimitVal = new Decimal(maxLimit);
    if (walletBalanceVal.gt(maxLimitVal)) {
      setisApproved(false);
    } else {
      setisApproved(true);
    }
  }

  const handlewithdrawAmoutChange = (event: any) => {
    setwithdrawAmout(event.target.value);
  };


  const updateWithdrawMax = () => {
    setwithdrawAmout(userShare);
  }


  const showSuccess = (message: string) => {
    toast.current?.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
  }

  const showWarn = (header: string, message: string) => {
    toast.current?.show({ severity: 'warn', summary: header, detail: message, life: 3000 });
  }

  const showError = (message: string) => {
    toast.current?.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
  }

  const getContract = (address: string, abi: any, provider: any) => {
    const web3 = new Web3(provider);
    return new web3.eth.Contract(abi, address);
  }

  const getEtherContract = (address: string, abi: any, provider: any) => {
    return new ethers.Contract(address, abi, provider);
  }

  const networkSwitchHandler = (networkId: number) => {
    (switchNetwork as any).switchNetwork(networkId)
  };
  const getTwoDecimal = (num: any) => {
    const roundedNum = Math.floor(num * 100) / 100;
    return roundedNum.toFixed(2);
  }
  const getFormatedData = (x: any) => {
    if (isNaN(x)) return x;

    if (x < 999) {
      return getTwoDecimal(x);
    }

    if (x < 1000) {
      return getTwoDecimal(x);
    }

    if (x < 10000) {
      return getTwoDecimal(x / 1000) + "K";
    }

    if (x < 100000) {
      return getTwoDecimal(x / 1000) + "K";
    }

    if (x < 1000000) {
      return getTwoDecimal(x / 1000) + "K";
    }

    if (x < 10000000) {
      return getTwoDecimal(x / 1000000) + "M";
    }

    if (x < 1000000000) {
      return getTwoDecimal(x / 1000000) + "M";
    }

    if (x < 1000000000000) {
      return getTwoDecimal(x / 1000000000) + "B";
    }

    return "1T+";
  }

  const fnum = (x: any) => {
    if (isNaN(x)) return x;

    if (x < 999) {
      return getTwoDecimal(x);
    }

    if (x < 1000) {
      return getTwoDecimal(x);
    }

    if (x < 10000) {
      return getTwoDecimal(x / 1000) + "K";
    }

    if (x < 100000) {
      return getTwoDecimal(x / 1000) + "K";
    }

    if (x < 1000000) {
      return getTwoDecimal(x / 1000) + "K";
    }
    if (x < 10000000) {
      return getTwoDecimal(x / 1000000) + "M";
    }

    if (x < 1000000000) {
      return getTwoDecimal(x / 1000000) + "M";
    }

    if (x < 1000000000000) {
      return getTwoDecimal(x / 1000000000) + "B";
    }

    return "1T+";
  }

  const goToUrl = (url: any) => {
    window.open(url, '_blank');
  }

  interface CustomTabHeaderProps {
    icon: string;
    title: string;
  }

  const CustomTabHeader: React.FC<CustomTabHeaderProps> = ({ icon, title }) => {
    return (
      <>
        {icon && <img src={icon} alt="Icon" style={{ marginRight: '10px', width: '28px' }} />}
        <span>{title}</span>
      </>
    );
  };


  //chart js start

  const graphInitialization = (labels: any[], values: any[]) => {

    ChartJS.register(
      CategoryScale,
      LinearScale,
      PointElement,
      LineElement,
      Title,
      TooltipChart,
      Legend
    );

    const options = {
      responsive: true,
      plugins: {
        legend: {
          position: 'top' as const,
        },
        title: {
          display: true,
          text: '',
        },
      },
    };
    const data = {
      labels,
      datasets: [
        {
          label: 'Vault Share Price',
          data: values,
          borderColor: 'rgba(145, 77, 229, 1)',
          backgroundColor: 'rgba(145, 77, 229, 1)',
        }
      ],
    };

    setGraphOption(options);
    setgraphData(data);

  }

  //chart js end
  // highlight section start
  // Get all sections that have an ID defined
  const sections = document.querySelectorAll("section[id]");
  // Add an event listener listening for scroll
  window.addEventListener("scroll", navHighlighter);

  function navHighlighter() {
    // Get current scroll position
    let scrollY = window.pageYOffset;

    // Now we loop through sections to get height, top and ID values for each
    sections.forEach((current: any) => {
      const sectionHeight = current['offsetHeight'];
      const sectionTop = (current.getBoundingClientRect().top + window.pageYOffset) - 100;
      const sectionId = current.getAttribute("id");

      if (
        scrollY > sectionTop &&
        scrollY <= sectionTop + sectionHeight
      ) {
        document.querySelector("#li_" + sectionId)?.classList.add("active");
      } else {
        document.querySelector("#li_" + sectionId)?.classList.remove("active");
      }
    });
  }

  const scrollToSection = (elementRef: any) => {
    window.scrollTo({
      top: elementRef.current.offsetTop - 70,
      behavior: "smooth",
    });
  };

  // highlight section end
  const getTagIcon = (tag: string): string => {
    switch (tag) {
      case 'Uptrend Market':
        return trend;
      case 'Active Strategy':
        return almImg;
      case 'Revenue Earning':
        return revenueEarningImg;
      case 'Wide Range':
        return almImg;
      case 'Pegged Strategy':
        return dynamicStrategyImg;
      case 'Static Range':
        return dynamicStrategyImg;
      case 'Dynamic':
        return dynamicStrategyImg;
      case 'LSD Farming':
        return LSDFarmingImg;
      case 'Volatile Pair':
        return VolatilePairColorImg;
      case 'Stable Pair':
        return StablePairColorImg;
      case 'Boosted':
        return boosted;

      default:
        return almImg;
    }
  };

  const getCurrentAllocation = (a: number, b: number, k: number): number => {
    const numerator = Math.sqrt(b / k) * (Math.sqrt(k) - Math.sqrt(a));
    const denominator = Math.sqrt(b) - Math.sqrt(k);
    return numerator / denominator;
  }

  const zeroDeno = Number(token0Dec) * Math.pow(10, 18)
  const oneDeno = Number(token1Dec) * Math.pow(10, 18)
  const Diff = Math.pow(10, (zeroDeno - oneDeno));
  const currentPrice = Math.pow(1.0001, deatils.currentTick)
  const newcurrentPrice = currentPrice * Diff;
  const lowerRangePrice = (Math.pow(1.0001, deatils.tickLower)) * Diff;
  const upperRangePrice = (Math.pow(1.0001, deatils.tickUpper)) * Diff;
  const currentAllocation = getCurrentAllocation(lowerRangePrice, upperRangePrice, newcurrentPrice);
  const token0Allocation = 100 / (1 + Math.abs(currentAllocation));
  const token1Allocation = 100 - 100 / (1 + Math.abs(currentAllocation));
  // const token1Allocation = 100 - 100 / (1 + currentAllocation);

  const performanceFee: number | undefined = deatils?.fundManagerFee + deatils?.protocolFee + deatils?.partnerFee / deatils?.feeDecimals * 100;

  const share1 = token0Allocation / 100;
  const share2 = token1Allocation / 100;

  return (
    <>
      <Toast ref={toast} />
      {loading ? <><div className="loader-container">
        <div className="spinner"></div>
      </div></> : <>
        <div className='custom-container mt-4'>
          <div className='row mob_clm_rvs'>
            <div className='col-md-8'>
              <div className="small-div-1"></div>
              <div className='first_section outer_section_detail notMobileDevice'>
                <div className='d_flex_frst'>
                  <div className='header_font_size redHatFont'><span><img src={deatils?.assetImg} alt='btc img' className='btc_asst_img_width' /></span><span><img src={deatils?.assetImg2} alt='btc img' className='btc_img_width' /></span>{deatils?.vaultName}</div>
                  <div className='chain_pos_det_v2'>
                    <span><img src={deatils?.networkImg} alt='chain' /></span>
                  </div>
                </div>
                <div className='dsp_flex_start dspWrap mt-3 mb-4'>
                  {/* mapping tags */}
                  {deatils?.tags.map((tag: string, index: number) => (
                    <div className='trdng_outer' key={index}>
                      <span className='trdng_width'>
                        <img src={getTagIcon(tag)} className='ml_8' alt={`${tag} img`} />
                        {tag}
                      </span>
                    </div>
                  ))}

                </div>
                <div className='dsp mb-3 wdth_100'>
                  <div className='mbl_mrgn_10'>APR
                    <br />
                    <div className='align-items-center d-flex'>
                      <span className='holding_val'>
                        {(deatils.lpApr + deatils.xirvApr).toFixed(2)}%
                      </span>
                      <img className={`toolTipPerformance ml_5`} src={infoCircleImg} alt='info' />
                      <Tooltip className='' target={`.toolTipPerformance`} mouseTrack mouseTrackLeft={10}>
                        LP: {(deatils.lpApr).toFixed(2)}%<br />
                        {deatils.xirvApr !== 0 && // Check if deatils.xirvApr is not zero
                          `xRIV: ${(deatils.xirvApr).toFixed(2)}%`
                        }
                      </Tooltip>
                    </div>
                  </div>

                  <div className='mbl_mrgn_10'>TVL <br /> <span className='fnt_wgt_600'>{fnum(Number(deatils.tvl))} {deatils?.assetName}</span></div>
                  <div className='mbl_mrgn_10'>DEX <br /> <span><img src={deatils?.poweredBy} className='wdth_140' alt='pancake' /></span></div><div>LP Pool & Fee Tier <br /> <span className='fnt_wgt_600'>
                    <span>{deatils.vaultName.split('-').slice(0, 2).join('-')}{" "}</span>
                    <span >{" "}({(Number(deatils.feeTier) / Math.pow(10, 4)).toFixed(2)}%)</span>

                  </span></div>
                  {/* <div className='mbl_mrgn_10'>Safety Score <br /> <span className='holding_val'>9.5  <img src={saftyImg} alt='safty img' className='sftyImgWdth' /></span></div> */}
                </div>

              </div>


              <div className='second_section outer_section_detail nav_design ovrFlow'>
                <nav className="navigation">
                  <ul>
                    <li id='li_overview' onClick={() => scrollToSection(overview)}>Overview</li>
                    <li id='li_strategy' onClick={() => scrollToSection(strategy)}>Strategy</li>
                    <li id='li_yieldToken' onClick={() => scrollToSection(yieldToken)}>Yield Token</li>
                    {/*<li id='li_lpTokenDetails' onClick={() => scrollToSection(lpTokenDetails)}>LP Token</li>*/}
                    <li id='li_risk' onClick={() => scrollToSection(risk)}>Risk</li>
                    <li id='li_portfolioManager' onClick={() => scrollToSection(portfolioManager)}>Portfolio Manager</li>
                    <li id='li_fees' onClick={() => scrollToSection(fees)}>Fees</li>
                    {/* {(valutJsonData?.id !== "169") ? <> <li id='li_transactions' onClick={() => scrollToSection(transactions)}>Transactions</li></> : <></>} */}
                    <li id='li_fAQ' onClick={() => scrollToSection(fAQ)}>FAQ</li>
                  </ul>
                </nav>
              </div>
              <section id='overview' ref={overview}>
                <div className='third_section outer_section_detail'>
                  <div className='hdr_txt mb-3 redHatFont'>Overview</div>
                  <div className='dsp_cont'>
                    <div className='brdr_blck pdng_box mb-2'>TVL <div className='mt-2 fnt_wgt_600'>{fnum(Number(deatils.tvl))} {deatils?.assetName}</div></div>
                    <div className='brdr_blck pdng_box mb-2'>APR <div className='mt-2 txt_clr_grn'>{isDataLoadng ? <><Skeleton width="5rem" className="mb-2"></Skeleton></> : <>
                      <div className='align-items-center d-flex'>
                        <span className='holding_val'>
                          {(deatils.lpApr + deatils.xirvApr).toFixed(2)}%
                        </span>
                        <img className={`toolTipPerformance ml_5`} src={infoCircleImg} alt='info' />
                        <Tooltip className='' target={`.toolTipPerformance`} mouseTrack mouseTrackLeft={10}>
                          LP: {(deatils.lpApr).toFixed(2)}%<br />
                          {deatils.xirvApr !== 0 && // Check if deatils.xirvApr is not zero
                            `xRIV: ${(deatils.xirvApr).toFixed(2)}%`
                          }
                        </Tooltip>
                      </div>

                    </>}
                    </div></div>
                    <div className='brdr_blck pdng_box mb-2'>Denomination Asset <div className='mt-2 fnt_wgt_600'> <img src={deatils.denoImage} alt='btc img' className='wdth_28' /> {deatils.assetName}</div></div>

                    <div className='brdr_blck pdng_box mb-2'>Vault Contract <div className='mt-2 fnt_wgt_600'>{isDataLoadng ? <><Skeleton width="5rem" className="mb-2"></Skeleton></> : <>
                      {/* {vaultShare} {deatils?.assetName} */}
                      <span ><a href={`${deatils?.explorerLink}address/${deatils?.vaultAddress}`} target="_blank" rel="noreferrer">View on Explorer</a></span>
                    </>}
                    </div></div>

                  </div>

                </div>
              </section>
              <section id='strategy' ref={strategy}>
                <div className='third_section outer_section_detail'>
                  <div className='hdr_txt mb-2 redHatFont'>Strategy</div>
                  <div className='fnt_wgt_600 mb-2 redHatFont'>Summary</div>
                  <span>
                    <ul>
                      <li>{deatils?.description}</li>

                    </ul>
                  </span>

                  {valutJsonData?.protocols.map((data: any) => {
                    return <>
                      <div className='backGrd mb-3 '>
                        <div className='dsp mb-2'>
                          <div className='fnt_wgt_600 mb-3'><img src={data?.logo} className='wdth_140' alt='pancake' /></div>
                          <div className='d-flex mb-3'>
                            <div className='crsr_pntr' onClick={() => { goToUrl(data.website) }}>
                              <span className='westBtn hover101'><img src={globeImg} alt='website' /> Website</span>
                            </div>
                            <div className='crsr_pntr' onClick={() => { goToUrl(data.contract) }}>
                              <span className='westBtn hover101'><img src={arrowUpImg} alt='website' className='' /> Contract</span>
                            </div>
                          </div>
                        </div>
                        <div className='fnt_14 mt-3'>
                          {data.details}
                        </div>
                      </div>
                    </>
                  })}
                  <div className='dsp2Comp mb-2 mt-3'>
                    <div className='mtMob wdth_30'><div>Current Price</div><div className='fnt_wgt_600 redHatFont'>{(newcurrentPrice).toFixed(4)} {deatils.asset1.toLocaleUpperCase()}/{deatils.asset2.toLocaleUpperCase()} </div></div>
                    <div className='mtMob wdth_60 mlBanner'><div>Selected Range</div><div className='fnt_wgt_600 redHatFont'>{lowerRangePrice.toFixed(4)} - {upperRangePrice.toFixed(4)} {deatils.asset1.toLocaleUpperCase()}/{deatils.asset2.toLocaleUpperCase()}</div>
                      {/* <span className='fnt_wgt_600 redHatFont'> */}
                      {/* {deatils.vaultName.split('-').slice(0, 2).join('/')} */}
                      {/* </span> */}
                    </div>
                    <div className='mt-1'><div>Token Allocation</div><div className='fnt_wgt_600 redHatFont capOn'>{token0Allocation.toFixed(0)}% {deatils.asset1} + {token1Allocation.toFixed(0)}% {deatils.asset2}</div></div>
                  </div>
                  <div className='mt-1'>
                    <div className='hdr_tx mt-2 fnt_wgt_60Big'>Pool Comparison</div>
                    <div className='inStick mt-1'>
                      In Range
                    </div>
                    <div className='mt-05'>
                      <ProgressComparison productAProgress={token0Allocation} productBProgress={token1Allocation} />
                    </div>
                    <div className="containerde">
                      <div>
                        <div className="item d-flex align-items-center">
                          <img className='tokenImg' src={deatils.assetImg} alt={deatils.asset1} />
                          <div className='fnt_wgt_800 redHatFont'>{deatils.asset1}</div>
                          <div className='redhatFont'>{token0Allocation.toFixed(0)}%</div>
                        </div>
                        <div className=' fnt_wgt_500 ml-2'>$ {(Number(deatils.tvlInusd) * share1).toFixed(2)}</div>
                      </div>
                      <div>
                        <div className="item d-flex align-items-center">
                          <img className='tokenImg' src={deatils.assetImg2} alt={deatils.asset2} />
                          <div className='fnt_wgt_800 redHatFont'>{deatils.asset2}</div>
                          <div className='redhatFont'>{token1Allocation.toFixed(0)}%</div>
                        </div>
                        <div className='fnt_wgt_500 ml-2'>$ {(Number(deatils.tvlInusd) * share2).toFixed(2)}</div>
                      </div>
                    </div>

                  </div>
                </div>
              </section>

              <section id='yieldToken' ref={yieldToken}>
                <div className='third_section outer_section_detail'>
                  <div className='hdr_txt mb-2 redHatFont'>Yield Token</div>

                  <div className='dsp2 align-items-center  mb-2 mt-3'>
                    <div><div>Vault Name</div><div className='fnt_wgt_600 redHatFont'>{deatils?.vaultName}</div></div>
                    <div className=''><div>Token Symbol</div><div className='fnt_wgt_600 redHatFont'> {deatils?.symbol}</div></div>
                    <div className='mtMob'><div>Current Supply</div><div className='fnt_wgt_600 redHatFont'>
                      {deatils && `${(deatils.totalSupply / Math.pow(10, deatils.denominationDecimal)).toFixed(2)}`}{" "}{deatils.symbol}
                    </div></div>
                  </div>
                  <div className='dsp2 align-items-center  mb-2 mt-3'>
                    <div className=''><div>Price</div><div className='fnt_wgt_600 redHatFont'>{(Number(userPrice) * Math.pow(10, 15)).toFixed(4)} {deatils?.assetName}</div></div>

                    <div><div className='mltracker'>Token Tracker</div><div className='fnt_wgt_600 redHatFont'>
                      <span className='vOEX'><a href={`${deatils?.explorerLink}address/${deatils?.vaultAddress}`} target="_blank" rel="noreferrer">View on Explorer</a></span>

                    </div></div>
                    <div className='notMobileDevice'><div className='ft_content '></div><div className='fnt_wgt_600 redHatFont wdth_101'></div></div>
                  </div>
                </div>
              </section>

              <section id='risk' ref={risk}>
                <div className='fourth_section outer_section_detail'>
                  <span className='hdr_txt mb-2 redHatFont'>Risk</span>

                  <div className='mt-3'>
                    <ul className='pdng_18'>
                      <li className='mrgn_btm_15'><span className='fnt_wgt_600'>Principal Risk:</span> Impermanent loss associated with AMM liquidity farming can lead to a loss of principal amount.</li>
                      <li className='mrgn_btm_15'><span className='fnt_wgt_600'>Smart Contract Risk:</span>There is a risk of smart contract failure in the underlying vault or the protocols we work with.</li>
                    </ul>
                  </div>
                </div>
              </section>
              <section id='portfolioManager' ref={portfolioManager}>
                <div className='fifth_section outer_section_detail'>
                  <div className='hdr_txt mb-2 redHatFont'>Portfolio Manager</div>
                  <div className='mt-4'>
                    <span className='fnt_wgt_600'>Vault owner</span>
                    <div className='dsp portfolio_wdth_55 prtfol_back mt-2 mb-3'>
                      <div className='fnt_14 overflowWrap'>
                        {deatils?.vaultOwner}
                        <span className='ml_10'><a href={`${deatils?.explorerLink}address/${deatils?.vaultOwner}`} target="_blank" rel="noreferrer"><img src={eternalLinkImg} alt='external link img' /></a></span>
                      </div>

                    </div>
                  </div>
                  <div className='mt-4'>
                    <span className='fnt_wgt_600'>Fund Manager</span>
                    <div className='dsp portfolio_wdth_55 prtfol_back mt-2 mb-3'>
                      <div className='fnt_14 overflowWrap'>{deatils?.fundManger}
                        <span className='ml_10'><a href={`${deatils?.explorerLink}address/${deatils?.fundManger}`} target="_blank" rel="noreferrer"><img src={eternalLinkImg} alt='external link img' /></a></span>
                      </div>

                    </div>
                  </div>
                </div>
              </section>
              <section id='fees' ref={fees}>
                <div className='sixth_section outer_section_detail'>
                  <div className='hdr_txt mb-2 redHatFont'>Fees</div>
                  <div>
                    <table className="table_degn">
                      <thead>
                        <tr className='imDark '>
                          <th scope="col">Fee type</th>
                          <th scope="col">Rate</th>
                          <th scope="col">Recipient</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className='imDark'>
                          <td className='w-fit'>Performance Fee</td>
                          <td className='flexT'>
                            <div className='flexT'>{" "}{performanceFee}%</div>
                          </td>
                          <td>Protocol & Fund manager<br />
                          </td>
                        </tr>

                        <tr className='imDark'>
                          <td>Exit Fee</td>

                          <td className='flexT'>

                            <div>
                              <div>
                                {" "} {((deatils.withdrawFee) / (deatils.withdrawFeeDecimals)) * 100}%
                              </div>

                            </div>
                          </td>
                          <td>Protocol <br />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </div>
              </section>

              <section id='fAQ' ref={fAQ}>
                <div className='sixth_section outer_section_detail'>
                  <div className='hdr_txt mb-4 redHatFont'>FAQ</div>
                  <div>
                    <Accordion activeIndex={0}>
                      <AccordionTab header="Is there any lock-up period for funds?">
                        <p className="m-0">
                          No, there is no lock-up period in this vault. You can withdraw your funds at any time without any restriction or penalty.
                        </p>
                      </AccordionTab>
                      <AccordionTab header="What assets are the yields paid in?">
                        <p className="m-0">
                          The yields are paid in the denomination asset of the strategy and are compounded automatically. Unharvested rewards can be temporarily held in the form of farmed assets.
                        </p>
                      </AccordionTab>
                      <AccordionTab header="What are the fees associated with using the vault?">
                        <p className="m-0">
                          Rivera Vaults applies a performance fee that is automatically claimed during vault compounding. This means that all APR and portfolio balances you see in our platform are already adjusted for any fees charged. Selected vaults have an exit fee which will be deducted during the withdrawal. All fees are displayed in the deposit & withdrawal section for full transparency.
                        </p>
                      </AccordionTab>
                      <AccordionTab header="I'm having trouble using the app. What should I do?">
                        <p className="m-0">
                          Join our Discord community and help us improve our app by reporting your issue. Win exclusive rewards, bounty & more for your contribution.
                        </p>
                      </AccordionTab>
                      <AccordionTab header="I love Rivera! How can I get involved?">
                        <p className="m-0">
                          We are recruiting DeFi pros who can help us redefine the future of DeFi liquidity management. Join us in testing the Rivera protocol and contributing to its development. We are awarding exclusive OG NFTs to the top 100 testers. Get started by joining our Discord.
                        </p>
                      </AccordionTab>
                    </Accordion>
                  </div>
                </div>
              </section>
            </div>
            <div className='col-md-4'>
              <div className="small-div-2"></div>

              <div className='first_section outer_section_detail mobileDevice'>
                <div className='d_flex_frst'>
                  <div className='header_font_size redHatFont'><span><img src={deatils?.assetImg} alt='btc img' className='btc_asst_img_width' /></span><span><img src={deatils?.assetImg2} alt='btc img' className='btc_img_width' /></span>{deatils?.vaultName}</div>
                  <div className='chain_pos_det_v2'>
                    <span><img src={deatils?.networkImg} alt='chain' /></span>
                  </div>
                </div>
                <div className='dsp_flex_start dspWrap mt-3 mb-4'>
                  {valutJsonData?.isLiquidityMining ?
                    <><div className='trdng_outer'> <span className='trdng_width'><img src={almImg} className='ml_8' alt='arrow img' />Liquidity Mining</span> </div></> : <></>}

                  {valutJsonData?.isActiveStrategy ?
                    <><div className='trdng_outer mr_12'> <span className='trdng_width'><img src={almImg} className='ml_8' alt='arrow img' />Active Strategy</span> </div></> : <></>}

                  {valutJsonData?.isWideRange ?
                    <><div className='trdng_outer mr_12'> <span className='trdng_width'><img src={almImg} className='ml_8' alt='arrow img' />Wide Range</span> </div></> : <></>}

                  {valutJsonData?.isPeggedStrategy ?
                    <><div className='trdng_outer mr_12'> <span className='trdng_width'><img src={dynamicStrategyImg} className='ml_8' alt='arrow img' />Pegged Strategy</span> </div></> : <></>}

                  {valutJsonData?.isStaticRange ?
                    <><div className='trdng_outer mr_12'> <span className='trdng_width'><img src={dynamicStrategyImg} className='ml_8' alt='arrow img' />Static Range</span> </div></> : <></>}

                  {valutJsonData?.isDynamicStrategy ?
                    <><div className='trdng_outer'> <span className='trdng_width'><img src={dynamicStrategyImg} className='ml_8' alt='arrow img' />Dynamic</span> </div></> : <></>}


                  {valutJsonData?.isLSDFarming ?
                    <><div className='trdng_outer'> <span className='trdng_width'><img src={LSDFarmingImg} className='ml_8' alt='arrow img' />LSD Farming</span> </div></> : <></>}


                  {valutJsonData?.isVolatilePair ?
                    <>  <div className='trdng_outer'> <span className='trdng_width'><img src={VolatilePairColorImg} className='ml_8' alt='arrow img' />Volatile Pair</span> </div></> : <></>}

                  {valutJsonData?.isStablePair ?
                    <><div className='trdng_outer'> <span className='trdng_width'><img src={StablePairColorImg} className='ml_8' alt='arrow img' />Stable Pair</span> </div></> : <></>}
                </div>
                <div className='dsp mb-3 wdth_100'>
                  <div className='mbl_mrgn_10'>APR
                    <br />
                    <div className='align-items-center d-flex'>
                      <span className='holding_val'>
                        {(deatils.lpApr + deatils.xirvApr).toFixed(2)}%
                      </span>
                      <img className={`toolTipPerformance ml_5`} src={infoCircleImg} alt='info' />
                      <Tooltip className='' target={`.toolTipPerformance`} mouseTrack mouseTrackLeft={10}>
                        LP: {(deatils.lpApr).toFixed(2)}%<br />
                        {deatils.xirvApr !== 0 && // Check if deatils.xirvApr is not zero
                          `xRIV: ${(deatils.xirvApr).toFixed(2)}%`
                        }
                      </Tooltip>
                    </div>

                  </div>
                  <div className='mbl_mrgn_10'>TVL <br /> <span className='fnt_wgt_600'>{fnum(Number(deatils.tvl))} {deatils?.assetName}</span></div>
                  <div className='mbl_mrgn_10'>DEX <br /> <span><img src={deatils?.poweredBy} className='wdth_140' alt='pancake' /></span></div><div>LP Pool & Fee Tier <br /> <span className='fnt_wgt_600'>
                    <span>{deatils.vaultName}</span>
                    <span>({(Number(deatils.feeTier) / Math.pow(10, 4)).toFixed(2)}%)</span>

                    {/* <span>({(deatils.feeTier / Math.pow(10, 4)).toFixed(2)}%)</span> */}
                  </span></div>

                  {/* <div className='mbl_mrgn_10'>Safety Score <br /> <span className='holding_val'>9.5 <img src={saftyImg} alt='safty img' className='sftyImgWdth' /></span></div> */}
                </div>

              </div>

              {address ?
                <>
                  <div className='first_section outer_section_detail'>
                    <div className='dsp'>
                      <div>
                        <div className='holding_header'>
                          Your Holdings
                          <img className='toolTipHolding ml_5' src={infoCircleImg} data-pr-tooltip="The displayed portfolio balance has already accounted for the vault performance fee." alt='info' />
                          <Tooltip target=".toolTipHolding" mouseTrack mouseTrackLeft={10} />
                        </div>
                        <div className='holding_header_inner mb-3 secondary_color'>{Number(userShare).toFixed(4)} {deatils?.assetName}</div>
                      </div>
                      <div className='txtAlgnRight'>
                        <img src={dollarImg} className='dllrImgwdth' alt='dollar' />
                      </div>
                    </div>
                  </div>
                </> : <></>}


              <div className='second_section outer_section_detail pos_sticky'>
                <TabView>
                  <TabPanel header={<CustomTabHeader icon={depositTabImg} title="Deposit" />}>
                    <div className='mt-3'>
                      <div className='dsp'>
                        <div>Deposits</div>
                        <div>{fnum(Number(deatils.tvl))} {deatils?.assetName}</div>
                      </div>
                      <div>
                        <ProgressBar showValue={false} value={Number(((Number(deatils.tvlInusd) / Number(tvlCapInUsd)) * 100).toFixed(4))}></ProgressBar>
                      </div>
                      <div className='dsp mb-3'>
                        <div>Capacity</div>
                        <div>{fnum(Number(tvlCap))} {deatils?.assetName}</div>
                      </div>
                      <div className='dsp backGrd mb-3'>
                        <div className='fnt_wgt_600 text-center'><img src={deatils.denoImage} className='wdth_30_px' alt='usdt' /> <br /> {deatils?.assetName}</div>
                        <div>
                          <input
                            className='input_box_details'
                            type="number"
                            id="first_name"
                            name="first_name"
                            value={depositAmout}
                            onChange={handledepositAmoutChange}
                          />
                          <button className='btn mxBtn my-div' onClick={updateDepositMax}>Max</button>
                        </div>
                      </div>
                      <div className='dsp'>
                        <div>Wallet balance</div>
                        <div>{Number(walletBalance).toFixed(2)} {deatils?.assetName}</div>
                      </div>
                      <div className='dsp'>
                        <div className='buy_cake mt-1 mb-2'> <a target='_blank' href={deatils?.buyToken} className='clr_prpl' rel="noreferrer">Buy ${deatils?.assetName}</a></div>
                      </div>

                      <div className='mt-3 text-center'>
                        {isConnected ?
                          (chain as any)?.id !== Number(deatils?.chainId) ?
                            <button className='btn btn-riv-primary wdth_100' onClick={() => { networkSwitchHandler(Number(deatils?.chainId)) }} >Switch to {deatils?.chainName}</button>
                            : isApproved ? <button className='btn btn-riv-primary wdth_100' onClick={() => { deposit() }} disabled={isTransactionOnGoing}>Deposit</button>
                              : <button className='btn btn-riv-primary wdth_100' onClick={approveIntilize} disabled={isTransactionOnGoing}>Approve</button> :
                          <>
                            <div className='wdth_100'><ConnectBtn /></div>
                          </>}
                      </div>
                      <div className='mt-3 text-center'>
                        <div><img src={zapIMg} alt='dollar' /><span>Zap in with ${deatils?.assetName}</span></div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel header={<CustomTabHeader icon={withdrwaTabImg} title="Withdraw" />}>
                    <div className='mt-3'>
                      <div className='dsp'>
                        <div>Deposits</div>
                        <div>{fnum(Number(deatils.tvl))} {deatils?.assetName}</div>
                      </div>
                      <div>
                        <ProgressBar showValue={false} value={Number(((Number(deatils.tvlInusd) / Number(tvlCapInUsd)) * 100).toFixed(4))}></ProgressBar>
                      </div>
                      <div className='dsp mb-3'>
                        <div>Capacity</div>
                        <div>{fnum(Number(tvlCap))} {deatils?.assetName}</div>
                      </div>
                      <div className='dsp backGrd mb-3'>
                        <div className='fnt_wgt_600 text-center'><img src={deatils?.assetImg2} className='wdth_30_px' alt='usdt' /> <br /> {deatils?.assetName}</div>
                        <div><input
                          className='input_box_details'
                          type="number"
                          id="first_name_2"
                          name="first_name_2"
                          value={withdrawAmout}
                          onChange={handlewithdrawAmoutChange}
                        />
                          <button className='btn mxBtn my-div' onClick={updateWithdrawMax}>Max</button>
                        </div>
                      </div>
                      <div className='dsp'>
                        <div>Wallet balance</div>
                        <div>{Number(walletBalance).toFixed(2)} {deatils?.assetName}</div>
                      </div>
                      <div className='dsp'>
                        <div className='buy_cake mt-1 mb-2'> <a rel="noreferrer" target='_blank' href={deatils?.buyToken} className='clr_prpl'>Buy ${deatils?.assetName}</a></div>
                      </div>
                      <div className='mt-3 text-center'>

                        {isConnected ?
                          (chain as any)?.id !== Number(deatils?.chainId) ?
                            <button className='btn btn-riv-primary wdth_100' onClick={() => { networkSwitchHandler(Number(deatils?.chainId)) }} >Switch to {deatils?.chainName}</button>
                            : <button className='btn btn-riv-primary wdth_100' disabled={isTransactionOnGoing} onClick={withdraw}>Withdraw</button>
                          :
                          <>

                            <div className='wdth_100'><ConnectBtn /></div>
                          </>}
                      </div>
                      <div className='mt-3 text-center'>
                        <div><img src={zapIMg} alt='dollar' /><span>Zap out with ${deatils?.assetName}</span></div>
                      </div>
                    </div>
                  </TabPanel>
                </TabView>

              </div>
            </div>
          </div>
        </div>
      </>}
      <Dialog visible={approvalWaitingVisible} className='dialogWdth' onHide={() => setapprovalWaitingVisible(false)}>
        <div className='text-center'>
          <img src={waitingImg} alt='chain' className='gif_wdth' />
          <div className='header_font_size'>Waiting for Approval</div>
          <div>Transaction is pending on blockchain.</div>
        </div>
      </Dialog>
      <Dialog visible={approvalSuccessfullVisible} className='dialogWdth' onHide={() => setapprovalSuccessfullVisible(false)}>
        <div className='text-center'>
          <img src={waitingImg} alt='chain' className='gif_success_wdth' />
          <div className='header_font_size'>Approval Successful</div>
          <div>Opening Metamask, please confirm transaction in your wallet.</div>
        </div>
      </Dialog>

      <Dialog visible={openMetamaskVisible} className='dialogWdth' onHide={() => setOpenMetamaskVisible(false)}>
        <div className='text-center'>
          <img src={successfullImg} alt='chain' className='gif_success_wdth' />
          <div className='header_font_size'>Opening Metamask</div>
          <div>Please confirm transaction in your wallet.</div>
        </div>
      </Dialog>

      <Dialog visible={depositWaitingVisible} className='dialogWdth' onHide={() => setdepositWaitingVisible(false)}>
        <div className='text-center'>
          <img src={waitingImg} alt='chain' className='gif_wdth' />
          <div className='header_font_size'>Waiting for {transactionType}</div>
          <div>Transaction is pending on blockchain.</div>
        </div>
      </Dialog>

      <Dialog visible={depositSuccessfullVisible} className='dialogWdth' onHide={() => setdepositSuccessfullVisible(false)}>
        <div className='text-center'>
          <img src={successfullImg} alt='chain' className='gif_success_wdth' />
          <div className='header_font_size'>{transactionType} Successful</div>
          {transactionType === "Withdraw" ? <></> : <div>Great! You are invested now.</div>}
        </div>
      </Dialog>

    </>
  )
}
